import { Box, SxProps } from '@mui/material';

import { FC } from 'react';
import dynamic from 'next/dynamic';

const Lottie = dynamic(() => import('lottie-react'), {
  ssr: false,
});

export interface LottieProps {
  boxSx: SxProps;
  animationData: unknown;
}

export const LottiePlayer: FC<LottieProps> = ({ boxSx, animationData }) => {
  return (
    animationData && (
      <Box sx={boxSx}>
        <Lottie animationData={animationData} loop={true} />
      </Box>
    )
  );
};
